import { useService } from 'shared/providers';
import { I2PEnvironment } from 'shared/types';

export function useInsightEnvironment(): I2PEnvironment {
  const {
    appConfig: { serviceBaseUrl },
  } = useService();
  if (serviceBaseUrl.includes('modeling') || serviceBaseUrl.includes('dev')) {
    return 'dev';
  } else if (serviceBaseUrl.includes('sandbox')) {
    return 'sandbox';
  } else {
    return 'prod';
  }
}
